import './PermissionLegend.scss';

export { default } from './PermissionLegend';
